<!--AboutArea:区域解决方案 2021/12/20 14:05:16 YuAng-->

<template>
  <div class="ho-mobile-area">
    <mobile-banner :item="banner"></mobile-banner>
    <collapse-intro class="ho-page-part2" title="核心特性" :list="infos"></collapse-intro>
    <div class="ho-page-part3">
      <p class="ho-part-title">区域智慧教育，一站式解决</p>
      <p>
        <img width="100%" src="../../../../assets/images/mobile/area_part3_intro.png" />
      </p>
    </div>
    <product-intro class="ho-page-part4" :tabs="tabs" img-prefix="area/area-part4-"></product-intro>
  </div>
</template>
<script>
import CollapseIntro from '../components/CollapseIntro.vue'
import MobileBanner from '../components/MobileBanner.vue'
import ProductIntro from '../components/ProductIntro.vue'
export default {
  components: { MobileBanner, ProductIntro, CollapseIntro },
  name: 'AboutArea',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      banner: {
        name: 'area',
        title: '区域智慧教育解决方案',
        desc: '为区校打造，助力学校智慧教学，辅助区域统筹管理，实现区校一体化建设，促进区域教育资源均衡配置',
      },
      infos: [
        {
          title: '一站式满足区校需求',
          desc: '管理：区校一体化管理，实现统筹规划<br />教学：备授课、自学、学情一站式服务<br />评价：基于教、学、考的精准过程性评价<br />研训：专业培训与研修，服务教师发展',
          fold: false
        },
        {
          title: '打造区校一体化资源生态',
          desc: '精品优质资源随取随用，保障教学使用<br />发挥名校资源引领性，促进资源创新<br />沉淀本地化优质资源，资源共享共建',
          fold: true
        },
        {
          title: '云模式部署，高效安全',
          desc: '高效性：微服务架构，部署快捷高效<br />安全性：统一登录与认证，数据更安全<br />经济性：部署成本低，专业团队运维<br />开放性：底层开放，平台应用一点接入',
          fold: true
        },
        {
          title: '聚合数据，消除数据孤岛',
          desc: '整合各教育业务数据，实现数据贯通<br />数据统一智能化分析，深挖数据价值<br />区校数据可视化展示，提供决策依据',
          fold: true
        }
      ],
      tabs: [
        {
          id: 1,
          mainTitle: '数字资源',
          children: [
            {
              id: 1,
              title: '高质量资源库',
              desc: '高质量资源服务，覆盖小初高全学段，有效解决教学资源不足与重复建设问题。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 2,
              title: '中小学试题库',
              desc: '优质丰富试题资源，一站式解决多场景使用，组卷阅卷无缝衔接，满足教学检测需求。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 3,
              title: '本地特色资源',
              desc: '沉淀地区优质资源，构建本地特色化资源库，实现区本优质资源库共建共享。',
              imgCount: 2,
              device: 'pc'
            }
          ]
        },
        {
          id: 2,
          mainTitle: '区域教学',
          children: [
            {
              id: 1,
              title: '智慧教学',
              desc: '以优质资源为内核，覆盖课前、课中、课后的教与学全流程，激发学习兴趣，培养自主学习能力，让教与学更高效。',
              imgCount: 1,
              device: 'pc'
            },
            {
              id: 2,
              title: '智慧考评',
              desc: '基于智能题库，采用“AI算法+老师助力+专家诊断”，满足区域考评需求，生成教师讲评报告、学生个性化考试报告。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 3,
              title: '智慧研训',
              desc: '提供教师专业培训与研修服务，助力教师基本技能提升与职业发展，帮助教师上好每一堂课。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 4,
              title: '智慧学习',
              desc: '提供丰富学生自学资源，教材同步、专项突破，助力学生个性化学习，巩固课堂学习成果。',
              imgCount: 2,
              device: 'pad'
            }
          ]
        },
        {
          id: 3,
          mainTitle: '区域数据',
          children: [
            {
              id: 1,
              title: '区域数据',
              desc: '对区域各校的业务数据进行汇总和分析，实现区域数据可视化，实时了解各学校情况，整体把控区域教育信息化发展概况。',
              imgCount: 1,
              device: 'pc'
            }
          ]
        },
        {
          id: 4,
          mainTitle: '区域管理',
          children: [
            {
              id: 1,
              title: '基础管理',
              desc: '提供区域平台全方面基础管理，满足日常管理工作的开展与运营。',
              imgCount: 1,
              device: 'pc'
            },
            {
              id: 2,
              title: '集成开放',
              desc: '整合教学、学习、考评、研训、管理等各类优质应用，满足个性化、多样性的智慧教与学的需求。',
              imgCount: 1,
              device: 'pc'
            },
            {
              id: 3,
              title: '教育门户',
              desc: '整合内外部资源，展示地区教育统一形象的专业门户，实现区域信息共享。',
              imgCount: 1,
              device: 'pc'
            }
          ]
        }
      ]
    }
  },
  created() {
    // 请求接口
  },
  mounted() {
    // 更新Dom
  },
  methods: {
    xxxAction: function (action) {
      console.log(action)
    }
  }
}
</script>

<style scoped>
.ho-mobile-area >>> .ho-mobile-banner.area {
  background-image: url(../../../../assets/images/mobile/area_banner_bg.png);
}

.ho-mobile-area >>> .ho-mobile-banner p {
  margin-bottom: 24px;
}

.ho-mobile-area >>> .pics {
  margin-top: -8px;
}

.ho-mobile-area >>> .pics img {
  width: 175px;
}

.ho-mobile-area >>> span.first {
  display: none;
}

.ho-page-part3 {
  background: #f8f8f8;
  padding: 16px 8px 32px 8px;
}

.ho-page-part4,
.ho-page-part2 {
  background: white;
}
</style>